import script from "./ProceedPO.vue?vue&type=script&setup=true&lang=js"
export * from "./ProceedPO.vue?vue&type=script&setup=true&lang=js"

import "./ProceedPO.vue?vue&type=style&index=0&id=f3bb80e4&lang=css"

const __exports__ = script;

export default __exports__